import { render, staticRenderFns } from "./SkillsPage.vue?vue&type=template&id=78c3fd1e&scoped=true&"
import script from "./SkillsPage.vue?vue&type=script&lang=ts&"
export * from "./SkillsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c3fd1e",
  null
  
)

export default component.exports